import React, { useState } from "react";
import axios from "axios";
import InvestmentCompareBox from "./InvestmentCompareBox";
import TaxSaving from "./TaxSaving";
import EnquiryDetails from "./EnquiryDetails";
import InvestmentPlanDetalis from "./InvestmentPlanDetalis";
import SMCInvestementQuotation from "./SMCInvestementQuotation";
import InvestmentAddDetails from "./InvestmentAddDetails";
import InvestmentQuoteFooter from "../components/InvestmentQuoteFooter";
import SMCInvestmentCompare from "./SMCInvestmentCompare";
import "../Investment/Investment.css";
import { generateLotNo } from "../components/CommonJS";
import { basePath } from "../index";
import { useLocation, useNavigate } from "react-router-dom";
import { BsStars } from "react-icons/bs";
import { FaRegFilePdf } from "react-icons/fa6";
import html2pdf from "html2pdf.js";
import { getAge, parseStringArray } from "./UtilityComponents/UtilityFunction";
import DataLoader from "../components/Loader/DataLoader";
import IsSmoke from "./IsSmokerPopup";
import { createRef } from "react";
import FundAllocationModal from "../components/modals/FundAllocationModal";
import { Modal } from "react-bootstrap";
import SelectionModal from "../components/modals/SelectionModal";
class SMCInvestmentQuotes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            MobileNo: "",
            Gender: "",
            EnquiryNo: "",
            PaymentTerm: "",
            DOB: "",
            Quotes: [],
            QuoteReq: null,
            IsCompareShow: false,
            IsLoader: false,
            CompareItem: [],
            ModelPremium: 0,
            PaymentFreq: "Y",
            Plans: [],
            APIResponsePercentage: 0,
            IsShowCompareModel: false,
            IsTaxShow: false,
            IsPlanShow: false,
            PlanKey: "",
            InsurerList: [],
            CalledPlans: [],
            showGuarantee: false,
            showParticipating: false,
            SelectedInsuere: [],
            PlanOption: 1,
            tobaco: false,
            isTobacoPopupVisible: false,
            isTobacoClicked: false,
            isQuoteLoaded: false,
            QuoteSources: [],
            selectedQuoteKey: "",
            IsPlanOptionChanged: false,
            HiddenQuotes: [],
            AllQuotes: [],
            IsAscendingOrder: true,
            btnGST: false,
            IsQuoteLoading: false,
            PendingRequest: 0,
            isSubmitDisabled: true,
            showFundAllocationModal: false,
            selectedInsurerId: null,
            fundList: [],
            IsShowMasterModal: false,
            OccupationList: [],
            EducationList:[],
            PayoutFrequencyByPlan: {},
            PayoutFrequencyListByPlan: {}
        }
        this.updateResult = this.updateResult.bind(this);
        this.childRef = createRef();
    }

    componentDidMount() {
        const prm = new URLSearchParams(window.location.search);

        /*if ((prm.get('Type') || prm.get('type')) === 'P') {
            window.location.replace(window.location.href.replace('/InvestmentQuotes', '/InvestmentProposal'));
            return;
        }*/

        const shareID = prm.get('shareid');

        if (shareID && (shareID.includes("$$"))) {
            window.location.replace(window.location.href.replace('/InvestmentQuotes', '/InvestmentProposal'));
            return;
        }

        if (prm.has('shareid') || prm.has('shareId') || prm.has('enquiryno') || prm.has('enquiryNo')) {
            this.getSharedDetails();
            this.setState({ showGuarantee: true });
        } else {
            let smokerPopupData = sessionStorage.getItem('isSmokerPopupCalled');
            if (smokerPopupData) {
                this.setState({ isTobacoPopupVisible: false });
            } else {
                this.setState({ isTobacoPopupVisible: true });
            }
            const storedQuoteReq = sessionStorage.getItem('QuoteReq');
            const storedInsurerList = sessionStorage.getItem('InsurerList');
            const storedResponse = sessionStorage.getItem('Quotes');
            if (storedQuoteReq && storedInsurerList && storedResponse) {
                this.setState({ showGuarantee: true });
                this.setState({ QuoteReq: JSON.parse(storedQuoteReq), InsurerList: JSON.parse(storedInsurerList), Quotes: JSON.parse(storedResponse), AllQuotes: JSON.parse(storedResponse) });
            } else {
            const { InsurerList, QuoteReq } = this.props?.location?.state;
            this.setState({ QuoteReq, InsurerList }, () => this.SaveEnquiryApi());

            const { location } = this.props;
            const state = location.state;
            if (state.previousPath === "investment") {
                this.setState({ showGuarantee: true });
            } else if (state.previousPath === "guaranteed") {
                this.setState({ showGuarantee: false })
            }
            }
        }
        this.callMasterAPI();
    }

    callMasterAPI = async (dob) => {
        const masterKey = ["OCCUPATION_INV", "QUALIFICATION"];
        const { QuoteReq } = this.state;
        const selectedDOB = dob || QuoteReq?.DOB;
        const data = await Promise.all(masterKey.map(r => axios.post(`central/centralcall/callreqwithheader`, { URL: "GetMasterOnQuote", Req: { InsurerId: 0, MasterType: r, DOB: selectedDOB } })));
        //const data = await Promise.all(masterKey.map(r => axios.post(`central/centralcall/callreqwithheader`, { URL: "GetMasterOnQuote", Req: { InsurerId:0, MasterType: r } })));
        for (let i = 0; i < masterKey.length; i++) {
            switch (masterKey[i]) {
                case "OCCUPATION_INV":
                    this.setState({ OccupationList: data[i].data.Data });
                    break;
                case "QUALIFICATION":
                    this.setState({ EducationList: data[i].data.Data });
                    break;
                default:
                    break;
            }
        }
    }

    getPlans = (insId, LotNo, i) => {

        const { QuoteReq } = this.state;
        let model = {
            "EnquiryNo": QuoteReq.EnquiryNo,
            "InsurerId": insId,
            "LotNo": LotNo
        }
        try {
            axios.post(`central/centralcall/callreqwithheader`, { URL: "GetPlans", Req: model })
                .then((res) => {
                    if (res.data.Data.length > 0 && res.data.StatusCode === 200) {
                        let planData = res.data.Data;
                        console.log(planData, "plan data");
                        
                        this.setState(prv => ({ Plans: [...prv.Plans, ...planData] }));
                        planData.forEach(r => this.getQuotation(r, axios.CancelToken.source()));
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

            if (i + 1 === this.state.InsurerList.length) {
                this.setState(prv => ({
                    ...prv,
                    IsQuoteLoading: false

                }))
            }
        }
        catch (e) {
            console.error(e)
        }/*
        finally {
            this.decrementPendingRequest()
        }*/
    };
    getQuotation = (plan, source) => {
        //this.incrementPendingRequest()


        const qt = {
            Image: plan.LogoURL,
            PlanName: plan.PlanName,
            Features: plan.Features,
            InsurerId: plan.InsurerId,
            PaymentTerm: plan.PaymentTerm,
            PlanId: plan.Id,
            IsLoader: true,
        }

       

        this.setState(prvState => ({ Quotes: [...prvState.Quotes, qt], QuoteSources: [...prvState.QuoteSources, source] }), () => this.quoteDetails(plan, source));

    }


    callQuoteByInsurerId = (quoteObj) => {
        const { QuoteReq, InsurerList, Quotes } = this.state;
        this.setState({ IsQuoteLoading: true });
        let filteredQuotes = Quotes?.filter(r => r.PlanId !== quoteObj.PlanId);
        QuoteReq.LotNo = generateLotNo(QuoteReq.EnquiryNo, 0);
        this.setState({ Quotes: filteredQuotes });
        axios.post(`central/centralcall/callreqwithheader`, { URL: "SaveEnquiry", Req: QuoteReq })
            .then((Res) => {
                if (Res.data.StatusCode === 200) {
                    this.getPlans(quoteObj.InsurerId, QuoteReq.LotNo, InsurerList.length - 1);
                }
            }).catch(error => console.log(error));

    }

    generatePDF = async () => {
        this.setState({ isDownloadPDF: true });
        let element = document.getElementById('CaptureProposal');
        let clonnedElement = element.cloneNode(true);
        const calcBar = clonnedElement.querySelector('.useful-bar');
        const editBtn = clonnedElement.querySelector('.EditVehicleDet');
        const compBox = clonnedElement.querySelectorAll('.CompareBox');
        if (editBtn) editBtn.remove();
        const hideBtns = clonnedElement.querySelectorAll('.IconContainer');
        const planDetails = clonnedElement.querySelectorAll('.PlanDetails');
        const pdfBtn = clonnedElement.querySelector('.CallRequest');
        const shareBtn = clonnedElement.querySelector('.ShareQuotesWhatsapp');
        const taxSavingIcons = clonnedElement.querySelectorAll('.taxSavingIcon');
        const quoteFooterSection = clonnedElement.querySelector('.quoteFooterSection');
        if (quoteFooterSection) quoteFooterSection.remove();
        if (taxSavingIcons.length > 0) {
            taxSavingIcons.forEach(item => item.remove());
        }
        if (shareBtn) shareBtn.remove();
        if (pdfBtn) pdfBtn.remove();
        if (planDetails.length > 0) {
            planDetails.forEach(item => item.remove());
        }
        if (hideBtns.length > 0) {
            hideBtns.forEach(item => item.remove());
        }
        if (compBox.length > 0) {
            compBox.forEach(item => item.remove());
        }
        if (calcBar) calcBar.remove();

        //create div element for Continue Journey URL
        let parentDiv = clonnedElement.querySelector('#PlanLeadQuoteId');
        let continueJourney = document.createElement('div');
        continueJourney.setAttribute("style", "margin-top: -20px; color: #30b524; text-decoration:none; font-weight:bold");
        let url = window.location.origin + window.location.pathname + "?enquiryno=" + this.state.QuoteReq?.EnquiryNo;
        continueJourney.innerHTML = `<a href=${url} target="_blank" style="color: #30b524; cursor:pointer">Continue Journey <i class="fa fa-arrow-right"></i> </a>`;
        parentDiv.insertBefore(continueJourney, parentDiv.children[1]);

        let opt = {
            margin: 0,
            filename: (this.state.EnquiryNo || '').replace("/", "_") + "_Quotaion" + '_Summary.pdf', //SMC/ENQ/23/1234_Quotation_Summary.pdf
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 8, letterRendering: true, useCORS: true, dpi: 192 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'l', putOnlyUsedFonts: true },
            enableLinks: true,
            height: clonnedElement.scrollHeight,
             pagebreak: { mode: 'avoid-all', before: '.page-break' }
        };
        try {
            await html2pdf().set(opt).from(clonnedElement).save();
            this.setState({ isDownloadPDF: false });
        } catch (err) {
            // Handle error
            console.error(err);
        }
    }


    setPlanOptionValue = () => {
        const PaymentTerm = this.state.QuoteReq?.PaymentTerm;
        const PolicyTerm = this.state.QuoteReq?.PolicyTerm;
        const combinations = [
            [7, 14],
            [7, 16],
            [8, 17],
            [8, 18],
            [9, 18],
            [9, 19],
            [9, 20],
            [14, 30],
        ];

        for (let value of combinations) {
            if (value[0] == PaymentTerm && value[1] == PolicyTerm) {
                this.setState({ PlanOption: 2 });
                return 2;
            }
        }

        this.setState({ PlanOption: 1 });
        return 1;
    }

    setPlanOptValue = () => {
        // Define your combinations based on the data in the image

        let PaymentTerm = this.state.QuoteReq?.PaymentTerm;
        PaymentTerm = parseInt(PaymentTerm);
        let PolicyTerm = this.state.QuoteReq?.PolicyTerm;
        PolicyTerm = parseInt(PolicyTerm);

        const planCombinations = [
            { ppt: 5, pt: [12, 15, 20, 25, 30], planOption: 1 },
            { ppt: 7, pt: [15, 20, 25, 30], planOption: 1 },
            { ppt: 8, pt: [16], planOption: 1 },
            { ppt: 9, pt: [18], planOption: 1 },
            { ppt: 10, pt: [15, 20, 25, 30], planOption: 1 },
            { ppt: 11, pt: [22], planOption: 1 },
            { ppt: 12, pt: [20, 24, 25, 30], planOption: 1 },
            { ppt: 13, pt: [26], planOption: 1 },
            { ppt: 14, pt: [28], planOption: 1 },
            { ppt: 15, pt: [30], planOption: 1 },

            { ppt: 1, pt: [15, 20, 30], planOption: 2 },
            { ppt: 7, pt: [14, 15, 16, 27, 28, 29], planOption: 2 },
            { ppt: 8, pt: [16, 17, 18], planOption: 2 },
            { ppt: 9, pt: [18, 19, 20], planOption: 2 },
            { ppt: 10, pt: [20, 21, 22, 30, 31, 32], planOption: 2 },
            { ppt: 11, pt: [22, 23, 24], planOption: 2 },
            { ppt: 12, pt: [24, 25, 26], planOption: 2 },
            { ppt: 13, pt: [26, 27, 28], planOption: 2 },
            { ppt: 14, pt: [28, 29, 30], planOption: 2 },
            { ppt: 15, pt: [30, 31, 32], planOption: 2 },

            { ppt: 1, pt: [15, 20, 30], planOption: 4 },
            { ppt: 7, pt: [14, 15, 16], planOption: 4 },
            { ppt: 8, pt: [16, 17, 18], planOption: 4 },
            { ppt: 9, pt: [18, 19, 20], planOption: 4 },
            { ppt: 10, pt: [20, 21, 22], planOption: 4 },
            { ppt: 11, pt: [22, 23, 24], planOption: 4 },
            { ppt: 12, pt: [24, 25, 26], planOption: 4 },
            { ppt: 13, pt: [26, 27, 28], planOption: 4 },
            { ppt: 14, pt: [28, 29, 30], planOption: 4 },
            { ppt: 15, pt: [30, 31, 32], planOption: 4 },
        ];


        for (const combo of planCombinations) {
            if (combo.ppt == PaymentTerm && combo.pt.includes(PolicyTerm)) {
                this.setState({ PlanOption: combo.planOption });
                return combo.planOption;
            }
        }
        this.setState({ PlanOption: this.state.PlanOption });
        return this.state.PlanOption;
    };

  /*  quoteDetails = (planData, source) => {
        let request = {
            "EnquiryNo": planData.EnquiryNo,
            "InsurerId": planData.InsurerId,
            "LotNo": planData.LotNo,
            "PlanId": planData.Id,
            "PlanOption": this.state.IsPlanOptionChanged ? this.state.PlanOption : this.setPlanOptValue()
        }
        if (planData.InsurerId === 156) {
            request.fundListRequest = this.state.fundList;
        };
        try {
            axios.post(`central/centralcall/callreqwithheader`, { URL: "Quotation", Req: request }, { cancelToken: source.token, })
                .then((Res) => {
                    const { Quotes } = this.state;
                    const qts = Quotes.filter(r => r.PlanId != planData.Id);

                    const Data = Res.data.Data;
                    if (Array.isArray(Data) && Data.length > 0) {
                        let validQuotes = Data.filter(item => item.QuoteStatus && item.ModelPremium > 0).map(row => ({
                            ...row,
                            PlanFeatures: planData.Features,
                            BrochureUrl: planData.BrochureUrl
                        }));

                        if (validQuotes.length > 0) {
                            this.setState(prv => ({
                                Quotes: [...qts, ...validQuotes],
                                AllQuotes: [...qts, ...validQuotes]
                            }));

                            let storedQuotes = sessionStorage.getItem('Quotes');
                            let quoteResponse = storedQuotes ? JSON.parse(storedQuotes) : [];
                            quoteResponse = [...quoteResponse, ...validQuotes];
                            sessionStorage.setItem('Quotes', JSON.stringify(quoteResponse));

                        } else {
                            this.setState({ Quotes: qts, AllQuotes: qts });
                        }
                    } else {
                        this.setState({ Quotes: qts, AllQuotes: qts });
                    }

                    *//*if (Res.data.Data.QuoteStatus) {
                        let data = Res.data.Data;
                        if (data?.ModelPremium > 0) {
                            data.PlanFeatures = planData.Features;
                            data.BrochureUrl = planData.BrochureUrl;
                            this.setState(prv => ({ Quotes: [...qts, data], AllQuotes: [...qts, data] }));
                            let quoteResponse = [];
                            let storedQuotes = sessionStorage.getItem('Quotes');
                            if (storedQuotes) {
                                storedQuotes = JSON.parse(storedQuotes);
                                quoteResponse = [...storedQuotes, data];
                            } else {
                                quoteResponse = [data];
                            }
                            sessionStorage.setItem('Quotes', JSON.stringify(quoteResponse));
                        }
                    }
                    else {

                        this.setState({ Quotes: qts, AllQuotes: qts });
                    }*//*
                })
                .catch((error) => {

                    this.setState(prv => ({ Quotes: prv.Quotes.filter(r => r.PlanId !== planData.Id), AllQuotes: prv.Quotes.filter(r => r.PlanId !== planData.Id) }));
                });
        } catch (err) {
            //console.log(err);
        }
    };*/


    quoteDetails = (planData, source) => {
        let request = {
            "EnquiryNo": planData.EnquiryNo,
            "InsurerId": planData.InsurerId,
            "LotNo": planData.LotNo,
            "PlanId": planData.Id,
            "PlanOption": this.state.IsPlanOptionChanged
                ? this.state.PlanOption
                : this.setPlanOptValue()
        };

        if (planData.InsurerId === 156) {
            request.fundListRequest = this.state.fundList;
        }

        try {
            axios.post(
                `central/centralcall/callreqwithheader`,
                { URL: "Quotation", Req: request },
                { cancelToken: source.token }
            )
                .then((Res) => {
                    const Data = Res.data.Data;
                    console.log(Data, "plan data quotes");
                    
                    this.setState((prev) => {
                        
                        const qts = prev.Quotes.filter(
                            (r) => String(r.PlanId) !== String(planData.Id)
                        );

                        if (Array.isArray(Data) && Data.length > 0) {
                            
                            let validQuotes = Data.filter(
                                (item) => item.QuoteStatus && item.ModelPremium > 0
                            ).map((row) => ({
                                ...row,
                                PDFUrl: row?.PDFUrl || row?.PFDUrl || "",
                                PlanFeatures: planData.Features,
                                BrochureUrl: planData.BrochureUrl,
                            }));

                            if (validQuotes.length > 0) {
                                let updatedQuotes = [...qts, ...validQuotes];

                                
                                let storedQuotes = sessionStorage.getItem("Quotes");
                                let quoteResponse = storedQuotes
                                    ? JSON.parse(storedQuotes)
                                    : [];
                                quoteResponse = [...quoteResponse, ...validQuotes];
                                sessionStorage.setItem(
                                    "Quotes",
                                    JSON.stringify(quoteResponse)
                                );

                                const payoutFrequencyListByPlan = {};
                                const payoutFrequencyByPlan = {};
                                Data.forEach((item) => {
                                    const planId = String(item.PlanId);
                                    if ((planId === "52" || planId === "56") && item.QuoteStatus && Array.isArray(item.payOutFrequencyList) && item.payOutFrequencyList.length > 0) {
                                        payoutFrequencyListByPlan[planId] = item.payOutFrequencyList;
                                        payoutFrequencyByPlan[planId] = prev.PayoutFrequencyByPlan?.[planId] || item.PayoutFrequency || item.payOutFrequencyList[0]?.Value;
                                    }
                                });

                                return {
                                    Quotes: updatedQuotes,
                                    AllQuotes: updatedQuotes,
                                    PayoutFrequencyListByPlan: { ...prev.PayoutFrequencyListByPlan, ...payoutFrequencyListByPlan },
                                    PayoutFrequencyByPlan: { ...prev.PayoutFrequencyByPlan, ...payoutFrequencyByPlan }
                                };
                            }
                        }

                    
                        return { Quotes: qts, AllQuotes: qts };
                    });
                })
                .catch(() => {
                  
                    this.setState((prev) => {
                        const qts = prev.Quotes.filter(
                            (r) => String(r.PlanId) !== String(planData.Id)
                        );
                        return { Quotes: qts, AllQuotes: qts };
                    });
                });
        } catch (err) {
            console.error(err);
        }
    };

    BuyNow = (buyObj) => {
        this.setState({ selectedQuoteKey: buyObj.TranKey });
        const { QuoteReq } = this.state;
        let QuoteSaveReq = {
            EnquiryNo: buyObj.EnquiryNo,
            InsurerID: buyObj.InsurerId,
            DoB: QuoteReq.DOB,
            FullName: QuoteReq.Name,
            SumAssured: buyObj.SumAssured,
            QuoteID: buyObj.QuoteID,
            MobileNo: QuoteReq.MobileNo,
            BrochureUrl: buyObj.BrochureUrl,
            EmailID: QuoteReq.EmailID,
            PaymentTerm: buyObj.PaymentTerm,
            PolicyTerm: buyObj.PolicyTerm,
            PaymentFreq: buyObj.PaymentFreq,
            TotalPremium: buyObj.TotalPremium,
            LotNo: buyObj.LotNo,
            TranKey: buyObj.TranKey,
            IsSmoker: this.state.tobaco
        };

        sessionStorage.setItem("obj", JSON.stringify(QuoteSaveReq))
        axios.post(`central/centralcall/callreqwithheader`, { URL: "SaveQuotation", Req: QuoteSaveReq })
            .then((Res) => {
                if (Res.data.StatusCode == 200) {
                    const { InsurerList } = this.state;
                    const insName = InsurerList.find(r => r.Key === buyObj.InsurerId).Value;
                    const biUrl = buyObj?.PDFUrl || buyObj?.PFDUrl || "";
                    if (this.props.navigate) {
                        this.props.navigate("/investmentProposal", {
                            state: { BuyData: buyObj, QuoteReq, BIURL: biUrl },
                        });
                    } else if (this.props.history?.push) {
                        this.props.history.push({
                            pathname: "/investmentProposal",
                            //search: `?enquiryno=${buyObj.EnquiryNo}&ins=${insName}&planname=${buyObj.PlanName}`,
                            state: { BuyData: buyObj, QuoteReq, BIURL: biUrl },
                        });
                    }
                } else {
                    this.setState({ selectedQuoteKey: '' });
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ selectedQuoteKey: '' });
            });
    };


    getSharedDetails = async () => {
        const prm = new URLSearchParams(window.location.search);
        let model = {};

        if (prm.has('shareid') || prm.has('shareId')) {
            const shareId = prm.has('shareid') ? prm.get("shareid") : prm.get("shareId")
            model = { URL: "GetShareDetails", Req: { shareToken: decodeURIComponent(shareId), Stage: "QUOTATION" } }
        } else {
            const enqNo = prm.has('enquiryNo') ? prm.get('enquiryNo') : prm.get('enquiryno');
            model = { URL: "GetPolicyDetailsByEnqNo", Req: { EnquiryNo: enqNo } }
        }

        axios.post(`central/centralcall/callreqwithheader`, model)
            .then((Res) => {
                if (Res.data.StatusCode === 200) {
                    const data = Res.data.Data;
                    const QuoteReq = {
                        ...data.SaveEnquiryRequest,
                        DOB: data.SaveEnquiryRequest?.DoB,
                        Age: getAge(data.SaveEnquiryRequest?.DoB)
                    }
                    let Quotes = data?.Quotations?.filter(r => r.QuotationResponse.QuoteStatus).map(r => {
                        const p = data?.PlansRequests.flatMap(item => item.PlansResponse.Plans.filter(plan => plan.Id === r.QuotationResponse.PlanId))[0];
                        return ({ ...r.QuotationResponse, PlanFeatures: p?.Features, BrochureUrl: p?.BrochureUrl });
                    });
                    let hideinsurerIds = data?.HideInsurerIDs;
                    if (Array.isArray(hideinsurerIds) && hideinsurerIds.length > 0) {
                        hideinsurerIds = parseStringArray(hideinsurerIds);
                        Quotes = Quotes?.filter(qt => !hideinsurerIds.includes(qt.PlanId));
                    }

                    const payoutFrequencyListByPlan = {};
                    const payoutFrequencyByPlan = {};
                    Quotes?.forEach((qt) => {
                        const planId = String(qt.PlanId);
                        if ((planId === "52" || planId === "56") && Array.isArray(qt.payOutFrequencyList) && qt.payOutFrequencyList.length > 0) {
                            payoutFrequencyListByPlan[planId] = qt.payOutFrequencyList;
                            payoutFrequencyByPlan[planId] = qt.PayoutFrequency || qt.payOutFrequencyList[0]?.Value;
                        }
                    });

                    this.setState({
                        InsurerList: data.NewEnquiryResponse?.InsurerList,
                        QuoteReq,
                        Quotes,
                        AllQuotes: Quotes,
                        PayoutFrequencyByPlan: payoutFrequencyByPlan,
                        PayoutFrequencyListByPlan: payoutFrequencyListByPlan
                    })
                }
            });
    }

    resetSelectedInsurerFilter = () => {
        if (this.childRef.current) {
            this.childRef.current.resetSelectedInsurerState();
        }
    }

    SaveEnquiryApi = () => {
        sessionStorage.removeItem('Quotes');
       // sessionStorage.remove('QuoteReq');
        this.resetSelectedInsurerFilter();
        this.setState({ IsQuoteLoading: true, HiddenQuotes:[] });
        const { QuoteReq } = this.state;
        this.callMasterAPI(QuoteReq?.DOB);
        QuoteReq.LotNo = generateLotNo(QuoteReq.EnquiryNo, 0);
        sessionStorage.setItem('QuoteReq', JSON.stringify(QuoteReq));
        axios.post(`central/centralcall/callreqwithheader`, { URL: "SaveEnquiry", Req: QuoteReq })
            .then((Res) => {
                if (Res.data.StatusCode === 200) {
                    const { InsurerList } = this.state;
                    InsurerList.forEach((r, i) => this.getPlans(r.Key, QuoteReq.LotNo, i));
                }
            })
            .catch((err) => {
                console.log(err)
            });
    };

    updateResult(data) {
        const { QuoteReq } = this.state;
        const { isChildPlan,
            ChildName,
            ChildGender,
            ChildDOB } = data;
        this.setState({
            QuoteReq: {
                ...QuoteReq, FullName: data.FullName, AnnualIncome: data.AnnualIncome, DOB: data.DOB, MobileNo: data.MobileNo, Email: data.Email ?? QuoteReq.Email, EmailID: data.Email ?? QuoteReq.EmailID, Age: data.Age, Gender: data.Gender, Occupation: data.Occupation, Education:data.Education, IsSmoker: data.IsSmoker, lifeAssuredDetails: {
                    ...QuoteReq.lifeAssuredDetails, isChildPlan, FullName: isChildPlan ? ChildName : "", Gender: isChildPlan ? ChildGender :"", DOB: isChildPlan ? ChildDOB :''
} },
            Quotes: [], Plans: [], CompareItem: [], AllQuotes: []
        }, () => this.SaveEnquiryApi());
        
    }

    plansGenerator(data) {
        this.setState({ SelectedInsuere: data });
    }


    IsTobaco = (value) => {
        const { QuoteReq } = this.state;
        if (QuoteReq.IsSmoker !== value) {
            sessionStorage.setItem('isSmokerPopupCalled', value);
            this.onCancel();
            this.setState(prv => ({
                QuoteReq: { ...prv.QuoteReq, IsSmoker: value },
                isTobacoPopupVisible: false,
                Quotes: [],
                QuoteSources: [], AllQuotes: []
            }), () => this.SaveEnquiryApi());
        } else {
            this.setState({ isTobacoPopupVisible: false });
            sessionStorage.setItem('isSmokerPopupCalled', false);
        }

    };

    onCancel = () => {
        this.state.QuoteSources.forEach(token => token.cancel())
    }


    handleHiddenQuotes = (planId) => {
        const { HiddenQuotes, Quotes, AllQuotes } = this.state;
        if (Quotes.length === 1) {
            alert(`You can not hide all the ${AllQuotes.length === 1 ? "Quote" : "Quotes"}`);
        } else {
            const filteredQuotes = Quotes.filter(qt => qt.PlanId !== planId);
            this.setState({ Quotes: filteredQuotes, HiddenQuotes: [...HiddenQuotes, planId], });

        }
    }
    showAllQuotes = () => {
        const { AllQuotes } = this.state;
        this.setState({ HiddenQuotes: [], Quotes: AllQuotes });
    }

    handleGST = (e) => {
        this.setState({ btnGST: e.target.checked });
    }
    handleSort = () => {
        this.setState(prev => ({ IsAscendingOrder: prev.IsAscendingOrder ? false : true }));
    }

    addFundList = (funds) => {
        const { QuoteReq } = this.state;
        const fundList = funds.reduce((acc, item) => {
            if (item.fundCode || item.percent) {
                const elem = { code: item.FundCode || "", percent: item.percent };
                acc.push(elem);
            }
            return acc;
        }, []);

        this.setState({ Quotes: [],fundList:fundList },()=> this.SaveEnquiryApi());
    }

    handleMarketLinkQuote = (mastersData) => {
        const { QuoteReq } = this.state;
        this.setState({ QuoteReq: { ...QuoteReq, Occupation: mastersData.Occupation, Education: mastersData.Education }, Quotes: [], IsShowMasterModal:false }, () => this.SaveEnquiryApi())
    }

    handlePayoutFrequencyChange = (planId, value) => {
        const planKey = String(planId);
        const { QuoteReq, Plans, Quotes, AllQuotes } = this.state;
        const plan = Plans.find(p => String(p.Id) === planKey);
        const existingQuote =
            Quotes.find(q => String(q.PlanId) === planKey) ||
            AllQuotes.find(q => String(q.PlanId) === planKey);

        const updatedQuoteReq = {
            ...QuoteReq,
            PayoutFrequency: value,
            LotNo: generateLotNo(QuoteReq.EnquiryNo, 0)
        };

        const planData = {
            EnquiryNo: updatedQuoteReq.EnquiryNo,
            InsurerId: plan?.InsurerId ?? existingQuote?.InsurerId,
            LotNo: updatedQuoteReq.LotNo,
            Id: plan?.Id ?? existingQuote?.PlanId,
            Features: plan?.Features ?? existingQuote?.PlanFeatures ?? existingQuote?.Features,
            BrochureUrl: plan?.BrochureUrl ?? existingQuote?.BrochureUrl,
            PlanName: plan?.PlanName ?? existingQuote?.PlanName,
            PaymentTerm: plan?.PaymentTerm ?? existingQuote?.PaymentTerm,
            LogoURL: plan?.LogoURL ?? existingQuote?.Image
        };

        if (!planData.InsurerId || !planData.Id) {
            this.setState(prev => ({
                PayoutFrequencyByPlan: { ...prev.PayoutFrequencyByPlan, [planKey]: value },
                QuoteReq: updatedQuoteReq
            }));
            return;
        }

        const loaderQuote = {
            Image: planData.LogoURL,
            PlanName: planData.PlanName,
            Features: planData.Features,
            InsurerId: planData.InsurerId,
            PaymentTerm: planData.PaymentTerm,
            PlanId: planData.Id,
            IsLoader: true
        };

        const replaceWithLoader = (list) =>
            Array.isArray(list)
                ? list.map(q => String(q.PlanId) === planKey ? loaderQuote : q)
                : list;

        const source = axios.CancelToken.source();

        this.setState(prev => ({
            PayoutFrequencyByPlan: { ...prev.PayoutFrequencyByPlan, [planKey]: value },
            QuoteReq: updatedQuoteReq,
            Quotes: replaceWithLoader(prev.Quotes),
            AllQuotes: replaceWithLoader(prev.AllQuotes),
            QuoteSources: [...prev.QuoteSources, source]
        }), () => {
            sessionStorage.setItem('QuoteReq', JSON.stringify(updatedQuoteReq));
            axios.post(`central/centralcall/callreqwithheader`, { URL: "SaveEnquiry", Req: updatedQuoteReq })
                .then((Res) => {
                    if (Res.data.StatusCode === 200) {
                        this.quoteDetails(planData, source);
                    }
                })
                .catch(() => {
                    this.setState(prev => {
                        const qts = prev.Quotes.filter(q => String(q.PlanId) !== planKey || !q.IsLoader);
                        const all = prev.AllQuotes.filter(q => String(q.PlanId) !== planKey || !q.IsLoader);
                        return { Quotes: qts, AllQuotes: all };
                    });
                });
        });
    }

    render() {
        const { APIResponsePercentage, IsLoader, QuoteReq, Quotes, CompareItem, IsShowCompareModel, IsTaxShow, IsPlanShow, PlanKey, InsurerList, SelectedInsuere, isTobacoPopupVisible, HiddenQuotes, IsAscendingOrder, btnGST, IsQuoteLoading, AllQuotes, showFundAllocationModal, IsShowMasterModal, OccupationList, EducationList, PayoutFrequencyByPlan, PayoutFrequencyListByPlan } = this.state;
        const { EnquiryNo } = QuoteReq ?? "";
        let fQuotes = Array.isArray(Quotes) ? [...new Set(Quotes?.map(item => item))] : [];
        fQuotes = SelectedInsuere.length > 0 ? fQuotes.filter(row => SelectedInsuere.includes(row.InsurerId)) : fQuotes;
        const IsDisableEvents = !(fQuotes.filter(r => r.IsLoader).length === 0);
        return !QuoteReq ? <DataLoader /> :
            <>
                {this.state.isDownloadPDF ? <div className="IsDownlodPDF"><span class="PDFloader"></span> <span class="PDFloaderText">Generating PDF</span></div> : ""}
                {!IsShowCompareModel && <div className="SmcInvestementMainPage" id="CaptureProposal" >
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style={{ height: "5px", width: `${APIResponsePercentage}%` }}></div>
                    </div>
                    <div className="InvestmentQuotes">
                        {isTobacoPopupVisible && (
                            <IsSmoke IsTobaco={this.IsTobaco} />
                        )}
                        <div className="PositionSikty">
                            <div
                                className="container"
                                style={{
                                    pointerEvents: !IsDisableEvents ? "auto" : "none",
                                    cursor: IsLoader ? "progress" : "auto",
                                }}
                            >
                                <InvestmentAddDetails
                                    ref={this.childRef}
                                    res={Quotes}
                                    Quotes={fQuotes}
                                    AllQuotes={AllQuotes}
                                    InsurerList={InsurerList}
                                    QuoteReq={QuoteReq}
                                    IsGuaranteed={!this.state.showGuarantee}
                                    IsParticipating={!this.state.showParticipating}
                                    getQuoteOnChange={(key, value) => {
                                        if (key === "PlanType" && value === "IIM") {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, InvestmentType: "PP", PolicyTerm: 80 }, IsPlanOptionChanged: true, PlanOption: 1, Plans: [], CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        }
                                        else if (key === "PlanType" && value === "LS") {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, InvestmentType: "GP", PolicyTerm: 20 }, IsPlanOptionChanged: true, PlanOption: 1, Plans: [], CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        }
                                        else if (key === "PlanType" && value === "IST") {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, InvestmentType: "GP", PaymentTerm: 5, PolicyTerm: 10 }, IsPlanOptionChanged: true, PlanOption: 1, Plans: [], CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        }
                                        else if (key === "PlanType" && value === "ILT") {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, InvestmentType: "PP", PaymentTerm: 10, PolicyTerm: 20 }, IsPlanOptionChanged: true, PlanOption: 1, Plans: [], CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        }
                                        else if (key === "PaymentTerm" && parseInt(value) > parseInt(QuoteReq.PolicyTerm)) {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, PolicyTerm: value > 20 ? 40 : value }, IsPlanOptionChanged: false, Plans: [], CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        } else if (key === "InvestmentType" && value === "ML") {
                                            this.setState({ isSubmitDisabled: false, IsShowMasterModal: true, QuoteReq: { ...QuoteReq, [key]: value, PlanType: "LS", PolicyTerm: 30 }, Plans: [], IsPlanOptionChanged: false, CompareItem: [], })
                                        //} else if (key === "InvestmentType" && value !== "ML") {
                                        //    this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, PolicyTerm: 20,  Occupation:'', Education:'' }, Plans: [], IsPlanOptionChanged: false, CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        } else if (key === "InvestmentType" && value === "GP") {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, PolicyTerm: 20, PlanType: "LS", Occupation: '', Education: '' }, Plans: [], IsPlanOptionChanged: false, CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        }
                                        else if (key === "InvestmentType" && value === "PP") {
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value, PolicyTerm: 80, PlanType: "IIM", Occupation: '', Education: '' }, Plans: [], IsPlanOptionChanged: false, CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                        }
                                        
                                        else
                                            this.setState({ isSubmitDisabled: false, QuoteReq: { ...QuoteReq, [key]: value }, Plans: [], IsPlanOptionChanged: false, CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())
                                    }}
                                    handlePremiumAndFreq={(prem, freq) => this.setState({ QuoteReq: { ...QuoteReq, ModelPremium: prem, PaymentFreq: freq }, Plans: [], CompareItem: [], Quotes: [] }, () => this.SaveEnquiryApi())}
                                    onPaymentFreqChange={(data) => this.setState({ QuoteReq: { ...QuoteReq, PaymentFreq: data }, Plans: [], CompareItem: [] })}
                                    UpdateResult={this.updateResult}
                                    plansGenerator={(data) => this.plansGenerator(data)}
                                    isSubmitDisabled={this.state.isSubmitDisabled}
                                    onSubmit={() => this.setState({ Quotes: [] }, this.SaveEnquiryApi())}
                                    OccupationList={OccupationList ?? []}
                                    EducationList={EducationList ?? []}
                                    onDobChange={(dob) => this.callMasterAPI(dob)}
                                    
                                />
                            </div>
                        </div>
                        <div className="container">
                            <EnquiryDetails IsQuoteLoading={IsQuoteLoading} QuoteReq={QuoteReq} Quotes={fQuotes} HiddenQuotes={HiddenQuotes} LotNo={QuoteReq.LotNo} EnquiryNo={EnquiryNo} IsAscendingOrder={IsAscendingOrder} btnGST={btnGST} handleSort={() => this.handleSort()} handleGST={(e) => this.handleGST(e)} />
                        </div>


                        <div class="CallRequest">
                            <button onClick={this.generatePDF} class="showOpt" id="MoreOption">
                                <span><BsStars /></span>
                                <span><FaRegFilePdf /></span>
                                <span>Generate PDF</span>
                            </button>
                        </div>

                        <div className="container">
                            {fQuotes.sort((a, b) => IsAscendingOrder ? a.MaturityBenefit - b.MaturityBenefit : b.MaturityBenefit - a.MaturityBenefit).map((response, index) => {
                                const planId = String(response.PlanId);
                                const payoutFrequencyList = PayoutFrequencyListByPlan?.[planId] || response.payOutFrequencyList;
                                const payoutFrequencyValue = PayoutFrequencyByPlan?.[planId] || response.PayoutFrequency || payoutFrequencyList?.[0]?.Value;

                                return (
                                    <SMCInvestementQuotation
                                        key={index}
                                        BuyNow={this.BuyNow}
                                        CompareItem={CompareItem}
                                        QuoteData={response}
                                        AddCompareBoxItem={(data) => this.setState({ CompareItem: [...CompareItem, data] })}
                                        RemoveItemFromCompareBox={(d) => this.setState({ CompareItem: CompareItem.filter(r => r.PlanName !== d) })}
                                        onPlanOptionChange={(d) => this.setState({ PlanOption: d, IsPlanOptionChanged: true }, () => this.callQuoteByInsurerId(response))}
                                        PlanOption={this.state.PlanOption}
                                        onTobacoChange={this.IsTobaco} tobacoValue={this.state.tobaco}
                                        isQuoteLoaded={this.state.isQuoteLoaded}
                                        selectedQuoteKey={this.state.selectedQuoteKey}
                                        handleHiddenQuotes={this.handleHiddenQuotes}
                                        AllQuotes={fQuotes}
                                        btnGST={btnGST}
                                        handleAutoPay={(flag) => this.setState({ QuoteReq: { ...QuoteReq, IsAutoPay: flag }, Quotes: [] }, () => this.SaveEnquiryApi())}
                                        handleSumAssured={(sumAssured) => this.setState({ QuoteReq: { ...QuoteReq, SumAssured: parseInt(sumAssured), }, Quotes: [] }, () => this.SaveEnquiryApi())}
                                        showFundAllocationModal={(insurerId) => this.setState({ showFundAllocationModal: true, selectedInsurerId: insurerId })}
                                        saveFundList={this.addFundList}
                                        payoutFrequencyList={payoutFrequencyList}
                                        payoutFrequencyValue={payoutFrequencyValue}
                                        onPayoutFrequencyChange={(value) => this.handlePayoutFrequencyChange(response.PlanId, value)}
                                    />
                                );
                            })}
                            {!IsDisableEvents && fQuotes.length === 0 && <p className="NQAvailable">No Quotes Available for Above Scenario</p>}
                        </div>
                        {CompareItem.length > 0 && (
                            <InvestmentCompareBox
                                CompareItem={CompareItem}
                                Close={() => this.setState({ CompareItem: [] })}
                                ShowCompareModel={() => this.setState({ IsShowCompareModel: true })}
                                RemoveItemFromCompareBox={(d) => this.setState({ CompareItem: CompareItem.filter(r => r.PlanName !== d) })}
                            />
                        )}

                        {IsShowMasterModal && <SelectionModal open={IsShowMasterModal} onSubmit={this.handleMarketLinkQuote} btnText="Submit" fields={[{ label: "Education", name: "Education", options: EducationList?.map(r => ({ name: r.MasterName, value: r.Code })) }, { label: "Occupation", name: "Occupation", options: OccupationList?.map(r => ({ name: r.MasterName , value:r.Code})) }]} />}

                        {IsPlanShow && <InvestmentPlanDetalis QuoteData={Quotes.filter(r => r.PlanName === PlanKey)} Details={this.BuyNow} />}
                        <div className="container quoteFooterSection">
                            <InvestmentQuoteFooter
                                MobileNu={QuoteReq?.MobileNo}
                                prefertime="Evening(5pm - 8pm)"
                                EnquiryTypeList="Investment Plan"
                            />
                        </div>
                        {HiddenQuotes.length > 0 && < div class="ClearQuote" onClick={this.showAllQuotes}>Show {HiddenQuotes.length} Hidden {HiddenQuotes.length > 1 ? "Quotes" : "Quote"}</div>}
                    </div>
                </div>}
                {IsShowCompareModel && (
                    <SMCInvestmentCompare
                        CompareItem={CompareItem}
                        Close={() => this.setState({ IsShowCompareModel: false })}
                        BuyNow={this.BuyNow}
                        EnquiryNo={QuoteReq.EnquiryNo}
                    />
                )}
            </>
    }

}

const SMCInvestmentQuotesWithRouter = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    return <SMCInvestmentQuotes {...props} location={location} navigate={navigate} />;
};

export default SMCInvestmentQuotesWithRouter;
